import { Component, input, output } from '@angular/core';

@Component({
  imports: [],
  selector: 'app-listing-details-cta-villages-mobile',
  styleUrl: './mobile.css',
  templateUrl: './mobile.html',
})
export class ListingDetailsCtaVillagesMobile {
  public readonly footnote = input.required<string>();
  public readonly image = input.required<string>();
  public readonly lppClicked = output();
  public readonly price = input.required<number>();
}
